export default "__VITE_ASSET__CKXNFGjL__"